import React from "react";
//#region types
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";

const CreateReconciliationExportView: React.FC = () => {
  return (
    <Grid whiteSpace={"pre-wrap"}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.CreateExportDialogMessage)}
    </Grid>
  );
};

export default CreateReconciliationExportView;
